import api from './api';
import type {
  BeaconAuditBatchesPagedResponse,
  BeaconAuditBatchDetail,
  BeaconAuditBatchStatus,
  CreateBeaconAuditBatchRequest,
  BeaconRateLimitStatusResponse,
} from '@/types/beaconAuditBatch';

const BASE = '/super-admin/beacon-audit-batches';

export const beaconAuditBatchApi = {
  async list(params: { page?: number; pageSize?: number; status?: BeaconAuditBatchStatus | null } = {}): Promise<BeaconAuditBatchesPagedResponse> {
    const qs = new URLSearchParams();
    if (params.page) qs.append('page', String(params.page));
    if (params.pageSize) qs.append('pageSize', String(params.pageSize));
    if (params.status) qs.append('status', params.status);
    const url = qs.toString() ? `${BASE}?${qs}` : BASE;
    const response = await api.get<BeaconAuditBatchesPagedResponse>(url);
    return response.data;
  },

  async get(id: number, params: { page?: number; pageSize?: number } = {}): Promise<BeaconAuditBatchDetail> {
    const qs = new URLSearchParams();
    if (params.page) qs.append('page', String(params.page));
    if (params.pageSize) qs.append('pageSize', String(params.pageSize));
    const url = qs.toString() ? `${BASE}/${id}?${qs}` : `${BASE}/${id}`;
    const response = await api.get<BeaconAuditBatchDetail>(url);
    return response.data;
  },

  async create(body: CreateBeaconAuditBatchRequest): Promise<{ batchId: number }> {
    const response = await api.post<{ batchId: number }>(BASE, body);
    return response.data;
  },

  async activate(id: number): Promise<void> {
    await api.post(`${BASE}/${id}/activate`);
  },

  async pause(id: number): Promise<void> {
    await api.post(`${BASE}/${id}/pause`);
  },

  async resume(id: number): Promise<void> {
    await api.post(`${BASE}/${id}/resume`);
  },

  async cancel(id: number): Promise<void> {
    await api.post(`${BASE}/${id}/cancel`);
  },

  async requeueFailed(id: number, itemIds?: number[]): Promise<{ requeuedCount: number }> {
    const response = await api.post<{ requeuedCount: number }>(`${BASE}/${id}/requeue-failed`, { itemIds: itemIds ?? null });
    return response.data;
  },

  async getRateLimitStatus(): Promise<BeaconRateLimitStatusResponse> {
    const response = await api.get<BeaconRateLimitStatusResponse>(`${BASE}/rate-limit/status`);
    return response.data;
  },

  async clearRateLimit(note?: string | null): Promise<{ id: number; clearedAt: string }> {
    const response = await api.post<{ id: number; clearedAt: string }>(`${BASE}/rate-limit/clear`, { note: note ?? null });
    return response.data;
  },
};

export default beaconAuditBatchApi;
